import { useMemo } from 'react';
import { UseColumnManagementProps, ColumnDef } from '../types/index';
import dropdownLists from '../DropdownLists';
import Filters from '../Filters';
import { formatAssociationType } from '@/utils/formatAssociationType';

export const useColumnManagement = ({ columns, tab }: UseColumnManagementProps) => {
  const memoizedColumns = useMemo(() => {
    let processedColumns: ColumnDef[] =
      columns?.map(col => {
        const filterDef = Filters.find((f: any) => f.name === col.name);
        const rawType = filterDef?.type || 'text';
        const filterType =
          rawType === 'number' ? 'number' : rawType === 'select' ? 'select' : 'text';

        let dropdownOptions = null;
        if (filterType === 'select') {
          if (col.name === 'associationType') {
            const isGDA = tab === 'GDA';
            const options =
              (isGDA ? dropdownLists.associationTypeGda : dropdownLists.associationTypeVda) ?? [];
            dropdownOptions = Array.isArray(options)
              ? options.map((c: string) => ({
                  id: c,
                  label: formatAssociationType(c),
                }))
              : null;
          } else if (col.name === 'source') {
            const sourceList = tab === 'GDA' ? dropdownLists.gdaSourcesList : dropdownLists.vdaSourcesList;
            dropdownOptions = Array.isArray(sourceList)
              ? sourceList.map((s: string) => ({
                  id: s,
                  label: s,
                }))
              : null;
          } else if (col.name === 'diseaseClassName_MSH') {
            const options =
              tab === 'VDA' ? dropdownLists.diseaseClassNameMshVda : dropdownLists.diseaseClassNameMshGda;
            dropdownOptions = Array.isArray(options)
              ? options.map((opt: string) => ({ id: opt, label: opt }))
              : null;
          } else if (col.name === 'prevalence') {
            const options = dropdownLists.disease_prevalence_class ?? [];
            dropdownOptions = Array.isArray(options)
              ? options.map((opt: string) => ({ id: opt, label: opt }))
              : null;
          } else if (dropdownLists[col.name]) {
            const options = dropdownLists[col.name];
            dropdownOptions = Array.isArray(options)
              ? options.map((opt: any) => ({ id: opt, label: opt }))
              : options;
          }
        }

        return {
          ...col,
          filterType,
          dropdownOptions,
        };
      }) || [];

    return processedColumns;
  }, [columns, tab]);

  return {
    memoizedColumns,
  };
};
